"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
interface UseFileDropOptions {
  enabled?: boolean;
  acceptedExtensions?: string[];
  onFile: (file: File) => void | Promise<void>;
}
function hasFiles(event: DragEvent): boolean {
  if (!event.dataTransfer) {
    return false;
  }
  return Array.from(event.dataTransfer.types).includes("Files");
}
function isAccepted(file: File, acceptedExtensions: string[]): boolean {
  const name = file.name.toLowerCase();
  return acceptedExtensions.some(ext => name.endsWith(ext));
}
export function useFileDrop(t0) {
  const $ = _c(9);
  const {
    enabled: t1,
    acceptedExtensions: t2,
    onFile
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [".json", ".bep"] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const acceptedExtensions = t3;
  const [isFileDragActive, setIsFileDragActive] = useState(false);
  let t4;
  let t5;
  if ($[2] !== acceptedExtensions || $[3] !== enabled || $[4] !== onFile) {
    t4 = () => {
      if (!enabled) {
        return;
      }
      let dragDepth = 0;
      const handleDragEnter = event => {
        if (!hasFiles(event)) {
          return;
        }
        dragDepth = dragDepth + 1;
        dragDepth;
        setIsFileDragActive(true);
      };
      const handleDragOver = _temp;
      const handleDragLeave = event_1 => {
        if (!hasFiles(event_1)) {
          return;
        }
        dragDepth = Math.max(0, dragDepth - 1);
        if (dragDepth === 0) {
          setIsFileDragActive(false);
        }
      };
      const handleDrop = async event_2 => {
        if (!hasFiles(event_2)) {
          return;
        }
        event_2.preventDefault();
        dragDepth = 0;
        setIsFileDragActive(false);
        const fileList = event_2.dataTransfer?.files;
        if (!fileList || fileList.length === 0) {
          return;
        }
        const files = Array.from(fileList);
        const accepted = files.find(file => isAccepted(file, acceptedExtensions)) ?? null;
        if (!accepted) {
          return;
        }
        await onFile(accepted);
      };
      window.addEventListener("dragenter", handleDragEnter);
      window.addEventListener("dragover", handleDragOver);
      window.addEventListener("dragleave", handleDragLeave);
      window.addEventListener("drop", handleDrop);
      return () => {
        window.removeEventListener("dragenter", handleDragEnter);
        window.removeEventListener("dragover", handleDragOver);
        window.removeEventListener("dragleave", handleDragLeave);
        window.removeEventListener("drop", handleDrop);
      };
    };
    t5 = [acceptedExtensions, enabled, onFile];
    $[2] = acceptedExtensions;
    $[3] = enabled;
    $[4] = onFile;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== isFileDragActive) {
    t6 = {
      isFileDragActive
    };
    $[7] = isFileDragActive;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}
function _temp(event_0) {
  if (!hasFiles(event_0)) {
    return;
  }
  event_0.preventDefault();
  if (event_0.dataTransfer) {
    event_0.dataTransfer.dropEffect = "copy";
  }
}